import React, { useState, useEffect } from 'react';
import styled from "styled-components";
import Banner from '../../Components/Banner';
import { ConvertToPounds } from '../../Components/Functions';
import { BookingPaymentType, BookingType } from '../../Components/Types';
import moment from 'moment';
import AddPaymentForm from './AddPaymentForm';
import BookingPaymentsTable from './BookingPaymentsTable';
import { useMsal } from '@azure/msal-react';
import ReactGA from "react-ga4";
import { BookingAPI } from 'API/BookingAPI';
import { PaymentAPI } from 'API/PaymentAPI';
import { useParams } from 'react-router-dom';
import ErrorMessage from 'Components/ErrorMessage';

const PageContainer = styled.div`
    padding: 3em;
    display:flex;
    justify-content:center;
`;
const Content = styled.div`
    width: 60%;
`;
const Note = styled.p`
    font-size: 0.8em;
`;
const Days = styled.span`
    font-family: Poppins-SemiBold;
    font-size: 1.2em;
    padding: 0.5em;
    
`;
const BookingRef = styled.p`
    text-align:right;
    color: var(--main-grey-color);
`;
const HeaderStyle = {
    fontFamily: "Poppins-SemiBold",
    fontSize: "1em"
}
function BookingPaymentsPage() {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    const { bookingId } = useParams<{ bookingId: string}>();
    const [booking, setBooking] = useState<BookingType>({} as BookingType);
    const [noBooking, setNoBooking] = useState<boolean>(false);
    const [bookingPayments, setBookingPayments] = useState<BookingPaymentType[]>([]);
    const { instance } = useMsal();
    
    useEffect(() => {
        const getData = async () => {
            try {
                const response = await BookingAPI.getSingle(instance, parseInt(bookingId ?? ""));
                const bookingData = response.booking;
                setBooking(bookingData)
                const startDate = new Date(Date.parse(bookingData.start_date));
                bookingData.days_left = moment(startDate).subtract(28, 'days').format("DD/MM/YYYY");
                var paymentResponse = await PaymentAPI.getAll(instance, parseInt(bookingId ?? ""));
                paymentResponse = paymentResponse.filter((p:BookingPaymentType) => p.payment_value && p.transaction_reference);
                setBookingPayments(paymentResponse);
            }
            catch {
                setNoBooking(true);
            }
        }
        getData();
    }, []);

    return (
        <>
            <Banner mainText="Payments" />
            <PageContainer>
                <Content>
                    {noBooking ?
                        <ErrorMessage />: 
                        <>
                            <Note>*Please note: your booking must be paid off in full prior to: <Days>{booking.days_left}</Days></Note>
                            <BookingRef>Booking ref: <span style={HeaderStyle}>{booking.booking_id}</span></BookingRef>
                            <BookingPaymentsTable bookingPayments={bookingPayments} />
                            <p style={HeaderStyle}>Total paid: {ConvertToPounds(booking.total_payment)}</p>
                            <p style={HeaderStyle}>To pay: {ConvertToPounds(booking.total_cost - booking.total_payment)}</p>
                            <p style={HeaderStyle}>Total cost: {ConvertToPounds(booking.total_cost)}</p>
                            {booking.total_cost - booking.total_payment > 0 && <AddPaymentForm booking={booking} /> }
                        </>
                    }
                    
                </Content>
            </PageContainer>
        </>
    );
}
export default BookingPaymentsPage;
